import { render, staticRenderFns } from "./AdaptiveTable.vue?vue&type=template&id=3ae28efc&scoped=true&"
import script from "./AdaptiveTable.vue?vue&type=script&lang=ts&"
export * from "./AdaptiveTable.vue?vue&type=script&lang=ts&"
import style0 from "./AdaptiveTable.vue?vue&type=style&index=0&id=3ae28efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae28efc",
  null
  
)

export default component.exports